import React, { useEffect, useState, useRef } from 'react';
import Fichearticle from './Fichearticle';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const correspondMois = (dateStr, offsetMois) => {
  if (!dateStr) return false;
  const now   = new Date();
  const cible = new Date(now.getFullYear(), now.getMonth() + offsetMois, 1);
  let d;
  if (typeof dateStr === 'string' && dateStr.includes('/')) {
    const [jour, moisStr, annee] = dateStr.split('/');
    d = new Date(Number(annee), Number(moisStr) - 1, Number(jour));
  } else {
    d = new Date(dateStr);
  }
  if (isNaN(d.getTime())) return false;
  return d.getFullYear() === cible.getFullYear() && d.getMonth() === cible.getMonth();
};

const ETAPES = [
  'Chargement des commandes fournisseurs...',
  'Chargement des commandes clients...',
  'Import des prévisions...',
  'Calcul du stock projeté...',
  'Analyse des ruptures...',
  'Calcul des dates de commande...',
  'Enregistrement dans PostgreSQL...',
  'Finalisation...',
];

const OFFSET_PAR_LABEL = {
  'M': 0, 'M+1': 1, 'M+2': 2, 'M+3': 3,
  'M+4': 4, 'M+5': 5, 'M+6': 6, 'M+7': 7,
  'M+8': 8, 'M+9': 9, 'M+10': 10, 'M+11': 11,
};

const getMoisLabel = (m) => {
  const offset = OFFSET_PAR_LABEL[m];
  if (offset === undefined) return '';
  const now  = new Date();
  const base = new Date(now.getFullYear(), now.getMonth() + offset, 1);
  return base.toLocaleDateString('fr-FR', { month: 'short', year: '2-digit' });
};

const getBgColor = (pourcentage) => {
  if (pourcentage > 100) return '#ffcdd2';
  if (pourcentage >= 80)  return '#c8e6c9';
  if (pourcentage >= 10)  return '#fff9c4';
  return '#ffcdd2';
};

// ── Composants réutilisables ──────────────────────────────────────
const Btn = ({ children, variant = 'primary', onClick, disabled, style: s }) => {
  const base = {
    border: 'none', borderRadius: '7px', padding: '8px 16px',
    cursor: disabled ? 'not-allowed' : 'pointer', fontWeight: 600,
    fontSize: '13px', transition: 'opacity 0.2s', opacity: disabled ? 0.6 : 1,
  };
  const variants = {
    primary: { background: '#3498db', color: 'white' },
    success: { background: 'linear-gradient(135deg, #3a7d44, #66bb6a)', color: 'white' },
    danger:  { background: '#e74c3c', color: 'white' },
    ghost:   { background: '#f0f0f0', color: '#555' },
  };
  return (
    <button style={{ ...base, ...variants[variant], ...s }} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

// ── Composant principal ───────────────────────────────────────────
const Suiviprevision = () => {
  const [previsions, setPrevisions]           = useState([]);
  const [references, setReferences]           = useState([]);
  const [selectedItem, setSelectedItem]       = useState('');
  const [commandesClient, setCommandesClient] = useState([]);
  const [modalItem, setModalItem]             = useState(null);
  const [searchRef, setSearchRef]             = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isRunning, setIsRunning]             = useState(false);
  const [progress, setProgress]               = useState(0);
  const [currentStep, setCurrentStep]         = useState('');
  const [scriptError, setScriptError]         = useState(false);

    useEffect(() => {
    document.title = 'MYSSA – Suivi prévisions';
  }, []);



  useEffect(() => {
    fetch(`${API}/prevision`)
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(data => setPrevisions(data.map(e => ({
        ITEM: e.Item, mois: e.Mois,
        Prevision: e.Prevision, "Commande ferme": e.Commande_ferme,
      }))))
      .catch(err => console.error('Erreur prévisions :', err));

    fetch(`${API}/base_de_donne_item`)
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(data => setReferences([...new Set(data.map(i => i.Item))]))
      .catch(err => console.error('Erreur références :', err));

    fetch(`${API}/base_de_donnee_cmde_client`)
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(data => setCommandesClient(data))
      .catch(err => console.error('Erreur commandes :', err));
  }, []);

  const lancerScript = () => {
    setIsRunning(true); setProgress(0);
    setCurrentStep(ETAPES[0]); setScriptError(false);
    const eventSource = new EventSource(`${API}/run-script`);
    let etapeIndex = 0;
    eventSource.onmessage = (event) => {
      const message = event.data;
      if (message === '__DONE__') {
        setProgress(100); setCurrentStep('Terminé avec succès ');
        eventSource.close(); return;
      }
      if (message.startsWith('ERREUR:')) {
        setScriptError(true); setCurrentStep('Erreur détectée');
        eventSource.close(); return;
      }
      etapeIndex = Math.min(etapeIndex + 1, ETAPES.length - 1);
      setProgress(Math.round((etapeIndex / ETAPES.length) * 95));
      setCurrentStep(ETAPES[etapeIndex]);
    };
    eventSource.onerror = () => {
      setScriptError(true); setCurrentStep('Connexion interrompue');
      eventSource.close();
    };
  };

  const fermerModal = () => { setIsRunning(false); setProgress(0); setScriptError(false); };

  const handleItemChange = (event) => {
    const value = event.target.value;
    setSelectedItem(value);
    if (!value) return;
    const dejaPresent = previsions.some(p => p.ITEM === value);
    if (dejaPresent) { alert(`La référence "${value}" est déjà présente.`); return; }
    const moisExistants = [...new Set(previsions.map(i => i.mois))];
    const moisAUtiliser = moisExistants.length > 0 ? moisExistants
      : ['M','M+1','M+2','M+3','M+4','M+5','M+6','M+7','M+8','M+9','M+10','M+11'];
    const commandesItem = commandesClient.filter(c => c.Item === value);
    const newEntries = moisAUtiliser.map(m => {
      const offset = OFFSET_PAR_LABEL[m];
      const commandeFerme = offset !== undefined
        ? commandesItem.filter(c => correspondMois(c["Date de livraison prevue"], offset))
            .reduce((acc, c) => acc + (Number(c.RAL) || 0), 0)
        : 0;
      return { ITEM: value, mois: m, Prevision: 0, "Commande ferme": commandeFerme };
    });
    setPrevisions(prev => [...prev, ...newEntries]);
  };

  const handleSave = async () => {
    if (previsions.length === 0) {
      if (!window.confirm('Tableau vide. Cela va vider la base puis relancer le calcul. Confirmer ?')) return;
      try {
        const r = await fetch(`${API}/prevision`, { method: 'DELETE', headers: { 'Content-Type': 'application/json' } });
        if (!r.ok) throw new Error(await r.text());
        lancerScript();
      } catch (e) { alert('Erreur suppression : ' + e.message); }
      return;
    }
    if (!window.confirm('Cela va remplacer toutes les données en base puis relancer le calcul. Confirmer ?')) return;
    const toutesLesEntrees = previsions.map(p => ({
      Item: p.ITEM, Mois: p.mois,
      Prevision: Number(p.Prevision) || 0,
      Commande_ferme: Number(p["Commande ferme"]) || 0,
    }));
    try {
      const r1 = await fetch(`${API}/prevision`, { method: 'DELETE', headers: { 'Content-Type': 'application/json' } });
      if (!r1.ok) throw new Error(await r1.text());
      const r2 = await fetch(`${API}/prevision`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(toutesLesEntrees),
      });
      if (!r2.ok) throw new Error(await r2.text());
      lancerScript();
    } catch (e) { alert('Erreur sauvegarde : ' + e.message); }
  };

  const handleSupprimer = (itemASupprimer) => {
    if (!window.confirm(`Supprimer "${itemASupprimer}" du tableau ?`)) return;
    setPrevisions(prev => prev.filter(p => p.ITEM !== itemASupprimer));
  };

  const handleInputChange = (event, item, mois) => {
    const { value } = event.target;
    setPrevisions(prev => prev.map(p => p.ITEM === item && p.mois === mois ? { ...p, Prevision: value } : p));
  };

  const suggestionsFiltrees = references
    .filter(r => r.toLowerCase().includes(searchRef.toLowerCase()))
    .slice(0, 30);

  const items = [...new Set(previsions.map(i => i.ITEM))];
  const mois  = [...new Set(previsions.map(i => i.mois))];

  return (
    <div style={{ padding: '28px 32px', fontFamily: "'Segoe UI', sans-serif" }}>

      {/* ── Modal script chargement ── */}
      {isRunning && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 9999, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '32px', width: '420px', boxShadow: '0 8px 32px rgba(0,0,0,0.18)', fontFamily: "'Segoe UI', sans-serif" }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
              <p style={{ margin: 0, fontSize: '17px', fontWeight: 700, color: '#2c3e50' }}>⚙️ Mise à jour des données</p>
            </div>
            <p style={{ fontSize: '13px', color: '#6c757d', marginBottom: '12px', minHeight: '18px' }}>{currentStep}</p>
            <div style={{ background: '#e9ecef', borderRadius: '99px', height: '8px', overflow: 'hidden', marginBottom: '6px' }}>
              <div style={{
                height: '100%', width: `${progress}%`, borderRadius: '99px', transition: 'width 0.4s ease',
                background: scriptError
                  ? '#e74c3c'
                  : 'linear-gradient(135deg, #3a7d44, #66bb6a)',
              }} />
            </div>
            <p style={{ textAlign: 'right', fontSize: '12px', color: '#aaa', marginBottom: '20px' }}>{progress}%</p>
            {(progress === 100 || scriptError) && (
              <Btn variant={scriptError ? 'danger' : 'success'} onClick={fermerModal} style={{ width: '100%' }}>
                {scriptError ? 'Fermer (erreur)' : 'Fermer'}
              </Btn>
            )}
          </div>
        </div>
      )}

      {/* ── Modal Fichearticle ── */}
      {modalItem && (
        <div onClick={() => setModalItem(null)} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '40px' }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: '12px', width: '90vw', maxWidth: '1800px', maxHeight: '85vh', overflowY: 'auto', padding: '24px', position: 'relative', boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }}>
            <button onClick={() => setModalItem(null)} style={{ position: 'absolute', top: '14px', right: '18px', background: 'none', border: '1.5px solid #ddd', borderRadius: '6px', padding: '4px 12px', fontSize: '13px', color: '#6c757d', cursor: 'pointer' }}>
              ✕ Fermer
            </button>
            <Fichearticle itemPrefill={modalItem} />
          </div>
        </div>
      )}

      {/* ── Header ── */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1 style={{ margin: 0, fontSize: '22px', fontWeight: 700, color: '#2c3e50' }}>
          📈 Suivi des prévisions
        </h1>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <span style={{ fontSize: '13px', color: '#888' }}>
            {items.length} référence{items.length > 1 ? 's' : ''}
          </span>
        </div>
      </div>

      {/* ── Barre de contrôles ── */}
      <div style={{ background: 'white', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.07)', padding: '14px 20px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>

        {/* Recherche référence avec autocomplete */}
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            value={searchRef}
            placeholder="Rechercher une référence…"
            onChange={(e) => { setSearchRef(e.target.value); setShowSuggestions(true); setSelectedItem(''); }}
            onFocus={() => setShowSuggestions(true)}
            onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
            style={{
              padding: '8px 12px', fontSize: '13px',
              border: '1.5px solid #ddd', borderRadius: '7px',
              width: '260px', outline: 'none', fontFamily: 'inherit',
              color: '#2c3e50',
            }}
          />
          {showSuggestions && searchRef && (
            <div style={{ position: 'absolute', top: '100%', left: 0, zIndex: 9999, background: '#fff', border: '1.5px solid #ddd', borderRadius: '7px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', maxHeight: 220, overflowY: 'auto', width: '260px', marginTop: 4 }}>
              {suggestionsFiltrees.length > 0 ? suggestionsFiltrees.map((ref, i) => (
                <div key={i}
                  onMouseDown={() => { setSearchRef(ref); setShowSuggestions(false); handleItemChange({ target: { value: ref } }); }}
                  style={{ padding: '8px 12px', fontSize: '13px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f8f9fa'}
                  onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                >
                  {ref}
                </div>
              )) : (
                <div style={{ padding: '8px 12px', fontSize: '13px', color: '#aaa' }}>Aucun résultat</div>
              )}
            </div>
          )}
        </div>

        {/* Bouton enregistrer */}
        <Btn variant="success" onClick={handleSave} disabled={isRunning}>
          {isRunning ? '⏳ En cours…' : '💾 Enregistrer les prévisions'}
        </Btn>
      </div>

      {/* ── Tableau ── */}
      <div style={{ background: 'white', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.07)', overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '620px' }}>
          <table style={{ borderCollapse: 'collapse', width: 'auto', minWidth: '100%', fontSize: '13px' }}>
            <thead>
              <tr style={{ background: '#f8f9fa', position: 'sticky', top: 0, zIndex: 1 }}>
                <th style={TH_FIXED}>Suppr.</th>
                <th style={TH_FIXED}>Item</th>
                <th style={TH_FIXED}>Type</th>
                {mois.map((m, i) => (
                  <th key={i} style={{ ...TH_BASE, minWidth: '100px', textAlign: 'center' }}>
                    {m}
                    <div style={{ fontSize: '11px', fontWeight: 400, color: '#aaa', marginTop: '2px' }}>
                      {getMoisLabel(m)}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && (
                <tr>
                  <td colSpan={3 + mois.length} style={{ padding: '32px', textAlign: 'center', color: '#aaa', fontSize: '13px' }}>
                    Aucune prévision — recherchez une référence pour commencer
                  </td>
                </tr>
              )}
              {items.map((item, index) => {
                const itemData = previsions.filter(p => p.ITEM === item);
                return (
                  <React.Fragment key={index}>

                    {/* Ligne Prévision */}
                    <tr style={{ borderTop: '2px solid #e9ecef' }}>
                      <td rowSpan={4} style={{ ...TD_FIXED, textAlign: 'center', verticalAlign: 'middle' }}>
                        <button onClick={() => handleSupprimer(item)} style={{ background: '#e74c3c', color: 'white', border: 'none', borderRadius: '6px', padding: '5px 9px', cursor: 'pointer', fontSize: '13px' }}>🗑</button>
                      </td>
                      <td rowSpan={4} onClick={() => setModalItem(item)}
                        style={{ ...TD_FIXED, cursor: 'pointer', color: '#3498db', fontWeight: 600, textDecoration: 'underline', verticalAlign: 'middle', whiteSpace: 'nowrap' }}
                        title="Ouvrir la fiche article">
                        {item}
                      </td>
                      <td style={{ ...TD_FIXED, color: '#6c757d', fontSize: '12px', fontWeight: 600 }}>Prévision</td>
                      {mois.map((m, idx) => {
                        const data      = itemData.find(p => p.mois === m);
                        const estBloque = ['M-4','M-3','M-2','M-1'].includes(m);
                        return (
                          <td key={idx} style={{ padding: '4px 6px', background: estBloque ? '#f0f0f0' : 'white', textAlign: 'center' }}>
                            <input type="number" value={data ? data.Prevision : ''}
                              onChange={(e) => handleInputChange(e, item, m)}
                              disabled={estBloque}
                              style={{ background: 'transparent', border: 'none', width: '100%', textAlign: 'center', fontSize: '13px', cursor: estBloque ? 'not-allowed' : 'text', outline: 'none', color: '#2c3e50' }}
                            />
                          </td>
                        );
                      })}
                    </tr>

                    {/* Ligne Commande ferme */}
                    <tr>
                      <td style={{ ...TD_FIXED, color: '#6c757d', fontSize: '12px', fontWeight: 600 }}>Commande ferme</td>
                      {mois.map((m, idx) => {
                        const data = itemData.find(p => p.mois === m);
                        return <td key={idx} style={{ padding: '4px 8px', textAlign: 'center', color: '#2c3e50' }}>{data ? data["Commande ferme"] : '-'}</td>;
                      })}
                    </tr>

                    {/* Ligne Prévision restante */}
                    <tr>
                      <td style={{ ...TD_FIXED, color: '#6c757d', fontSize: '12px', fontWeight: 600 }}>Prévision restante</td>
                      {mois.map((m, idx) => {
                        const data    = itemData.find(p => p.mois === m);
                        const restant = data ? Math.max(0, data.Prevision - data["Commande ferme"]) : '-';
                        return <td key={idx} style={{ padding: '4px 8px', textAlign: 'center', color: '#2c3e50' }}>{restant}</td>;
                      })}
                    </tr>

                    {/* Ligne % */}
                    <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <td style={{ ...TD_FIXED, color: '#6c757d', fontSize: '12px', fontWeight: 600 }}>%</td>
                      {mois.map((m, idx) => {
                        const data        = itemData.find(p => p.mois === m);
                        const prevision   = data ? Number(data.Prevision)         : 0;
                        const commande    = data ? Number(data["Commande ferme"]) : 0;
                        const pourcentage = prevision > 0 ? Math.round((commande / prevision) * 100) : 0;
                        return (
                          <td key={idx} style={{ padding: '4px 8px', textAlign: 'center', fontWeight: 700, fontSize: '12px', background: getBgColor(pourcentage), color: '#2c3e50' }}>
                            {pourcentage}%
                          </td>
                        );
                      })}
                    </tr>

                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

// ── Styles tableau partagés ───────────────────────────────────────
const TH_BASE = {
  padding: '10px 12px', fontSize: '12px', fontWeight: 600,
  color: '#6c757d', borderBottom: '2px solid #e9ecef',
  whiteSpace: 'nowrap', background: '#f8f9fa',
};
const TH_FIXED = {
  ...TH_BASE, textAlign: 'left',
  position: 'sticky', left: 0, zIndex: 2,
};
const TD_FIXED = {
  padding: '8px 12px', background: 'white',
  position: 'sticky', left: 0, zIndex: 1,
  borderRight: '1px solid #e9ecef',
};

export default Suiviprevision;